const socketDomain = {
  development: 'ws://58.87.88.201:9502',
  none: 'ws://58.87.88.201:9504',
  // none: 'ws://58.87.88.201:9503',
  production: 'ws://58.87.88.201:9502',
};

export { socketDomain };
